import { render, staticRenderFns } from "./ViewOrganizationUserTrips.vue?vue&type=template&id=1fea4f7f"
import script from "./ViewOrganizationUserTrips.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserTrips.vue?vue&type=script&lang=js"
import style0 from "./ViewOrganizationUserTrips.vue?vue&type=style&index=0&id=1fea4f7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports